
<script setup>
	import HBreak from '@/components/HBreak.vue';
	import StructuredPrayerList from '@/components/prayerDisplayComponents/StructuredPrayerList.vue';

	function queryPresent(queryParam){
		return queryParam === null || queryParam === "true";
	}

</script>

<template>
	<div class="home">
		<h1 v-if="!queryPresent($route.query.hideTitleHeader)">Prayer Wall</h1>
		<router-link :to="{name: 'PrayerSubmit', params: {clientId: $route.params.clientId} }">Submit a Prayer</router-link>
		<HBreak v-if="!queryPresent($route.query.hideTitleHeader)"/>
		<StructuredPrayerList :client="$route.params.clientId" :class="{marginless: queryPresent($route.query.marginlessMode)}"/>
	</div>
</template>

<style scoped>

.marginless{
	max-width: 100%;
	width: 100%;
}

</style>